import React, { useState, Fragment } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";

//components
import Navbar from "../../Components/Navbar/Navbar";

//css
import "./Manage.css";
import "../../Components/Navbar/Navbar.css";

import {
  getAllProducts,
  updateProductPriority,
} from "../../Helpers/apiCalls/Manage/Products";
import toast from "react-hot-toast";
import { toastStyle } from "../../Helpers/Utils/Common";

export default function ProductPriority() {
  let navigate = useNavigate();
  const [inactive, setInactive] = useState(false);

  //API
  const [productsData, setProductsData] = useState([]);
  const [searchProductName, setSearchProductName] = useState("");

  async function fetchProducts() {
    setProductsData([]);
    const response = await getAllProducts(searchProductName, "");

    if (response) {
      let result = response?.data?.data?.data.map((a) => {
        var info = a;
        info.product_name = a.name;
        info.type = "";
        return info;
      });
      setProductsData(result);
    } else if (response.error) {
      setProductsData([]);
    }
  }

  async function handleUpdatePriority() {
    const response = await updateProductPriority(productsData);

    if (response.data) {
      toast.success("Successfully updated product priority!", {
        style: toastStyle(),
      });
      setTimeout(() => {
        navigate("/products");
      }, 1000);
    } else {
      toast.error(response.data.response, {
        style: toastStyle(),
      });
    }
  }

  function handleProductChange(e, index) {
    const { name, value } = e.target;
    const list = [...productsData];
    list[index][name] = value;

    setProductsData(list);
  }

  React.useEffect(() => {
    // searchProducts();
    fetchProducts();
  }, []);

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"MANAGE"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-3">
          <Col xs={6}>
            <h1 className="page-title"> PRODUCTS PRIORITY </h1>
          </Col>
        </Row>
        <div className="edit-form mb-5">
          <Fragment>
            {productsData?.map((data, index) => {
              return (
                <Row className="mt-4 mb-2">
                  <Col>
                    <span className="edit-label"> {data.product_name} </span>
                  </Col>
                  <Col>
                    <Form.Control
                      type="number"
                      name="priority"
                      className="nc-modal-custom-text"
                      value={data.priority}
                      onChange={(e) => handleProductChange(e, index)}
                    />
                  </Col>
                </Row>
              );
            })}
            <Row>
              <Col className="d-flex justify-content-end mt-2 mb-0">
                <button
                  type="button"
                  className="button-secondary justify-content-end me-3"
                  onClick={() => navigate("/products")}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="button-primary justify-content-end"
                  onClick={() => handleUpdatePriority()}
                >
                  Update Priority
                </button>
              </Col>
            </Row>
          </Fragment>
        </div>
      </div>
    </div>
  );
}
